import { createRestApiClient } from '..';
export const fetchAvailableSizes = async (sizeData, sizeString) => {
  const trimmedData = sizeData?.map((value) => value.skuId);
  const finalData = trimmedData?.join(',');
  const restApiClient = createRestApiClient();
  const res = await restApiClient.request({
    method: 'GET',
    url: `api/getProductStatus`,
    params: {
      product_id: sizeString ? sizeString : (finalData ?? finalData),
    },
    headers: {
      platform: 'web',
    },
  });
  return res?.data;
};
